import { render, staticRenderFns } from "./SystemIntegrations.vue?vue&type=template&id=6bd85cf6&scoped=true&"
import script from "./SystemIntegrations.vue?vue&type=script&lang=js&"
export * from "./SystemIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./SystemIntegrations.vue?vue&type=style&index=0&id=6bd85cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd85cf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd85cf6')) {
      api.createRecord('6bd85cf6', component.options)
    } else {
      api.reload('6bd85cf6', component.options)
    }
    module.hot.accept("./SystemIntegrations.vue?vue&type=template&id=6bd85cf6&scoped=true&", function () {
      api.rerender('6bd85cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/SystemIntegrations.vue"
export default component.exports